/**
 * What Wix Forms does with each ricos design field.
 *
 * This is the shared half of the design contract: the token mapping `getFormSlotDesignStyle` writes. The panel's own metadata (which section a field belongs
 * to, which control draws it) lives with the panel, in the host package.
 *
 * Since `@wix/form-fields@3.2526.0` the React-Aria skin reads Harmony `--wst-button-primary-*` tokens
 * for the submit button and `--wst-box-secondary-*` tokens for the input boxes, so every ricos field
 * has a token to drive.
 */
export const FORM_SLOT_DESIGN_FIELDS = {
    // Ink. One token: `form-slot-block.scss` derives the label and muted inks from it.
    textColor: { vars: ['--wst-graphics-1-color'] },
    accentColor: { vars: ['--wst-links-and-actions-color'] },
    // Also paints the block's own surface, which the stylesheet reads off the same token.
    backgroundColor: { vars: ['--wst-primary-background-color'] },
    // Row and column gaps live in Forms' field-set-agnostic grid stylesheet, which reads them as
    // lengths, unlike the unitless numbers the old WUT skin wanted.
    rowGap: { vars: ['--wix-forms-formRowSpacing'] },
    columnGap: { vars: ['--wix-forms-formColumnSpacing'] },
    // Applied to the block itself, as one `padding` shorthand built from both fields.
    paddingHorizontal: { vars: [] },
    paddingVertical: { vars: [] },
    // Submit button.
    buttonColor: { vars: ['--wst-button-primary-background-color'] },
    buttonTextColor: { vars: ['--wst-button-primary-color'] },
    // Input boxes. The skin reads one colour and one radius but a width per side.
    borderColor: { vars: ['--wst-box-secondary-border-top-color'] },
    borderWidth: {
        vars: [
            '--wst-box-secondary-border-top-width',
            '--wst-box-secondary-border-bottom-width',
            '--wst-box-secondary-border-left-width',
            '--wst-box-secondary-border-right-width',
        ],
    },
    // One radius for inputs, the submit and step buttons and the appointment card. Inputs read only
    // the top-left corner; the buttons and the card read each corner.
    borderRadius: {
        vars: [
            '--wst-box-secondary-border-top-left-radius',
            '--wst-button-primary-border-top-left-radius',
            '--wst-button-primary-border-top-right-radius',
            '--wst-button-primary-border-bottom-right-radius',
            '--wst-button-primary-border-bottom-left-radius',
            '--wst-button-secondary-border-top-left-radius',
            '--wst-button-secondary-border-top-right-radius',
            '--wst-button-secondary-border-bottom-right-radius',
            '--wst-button-secondary-border-bottom-left-radius',
            '--wst-box-primary-border-top-left-radius',
            '--wst-box-primary-border-top-right-radius',
            '--wst-box-primary-border-bottom-right-radius',
            '--wst-box-primary-border-bottom-left-radius',
        ],
    },
};
/** Every design key, for the panel's "reset to theme" patch. */
export const ALL_DESIGN_KEYS = Object.keys(FORM_SLOT_DESIGN_FIELDS);
//# sourceMappingURL=design-fields.js.map